import { apiV1 } from "@/store";
import moment from "moment";

const state = {
  agentDeals: {
    reservations: {
      data: [],
      total: 0
    }
  },
  agentPhoneRentals: {
    phone_rentals: {
      data: [],
      total: 0
    }
  }
};

const actions = {
  getEffectiveRate: () => {
    const monthAndYear = moment().format("MMMM, YYYY");

    return new Promise((resolve, reject) => {
      apiV1.get(`/reporting/effective-rate`, {
        params: {
          "calculate_rank": true,
          "month_and_year": monthAndYear
        }
      })
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  getDealsNeedingAudit: () => {
    return new Promise((resolve, reject) => {
      apiV1.get(`/reporting/deals-needing-audit`)
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  getManuallyConvertedDeals: () => {
    return new Promise((resolve, reject) => {
      apiV1.get(`/reporting/manually-converted-deals`)
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  getManuallyDeniedDeals: () => {
    return new Promise((resolve, reject) => {
      apiV1.get(`/reporting/manually-denied-deals`)
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  getSelectedAgentLeads: ({ commit }, params) => {
    return new Promise((resolve, reject) => {
      apiV1.get(`/reporting/agent-reservations`, {
        params: params
      })
        .then((resp) => {
          commit("setSelectedAgentDeals", resp.data);
          resolve(resp);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  getSelectedAgentPhoneRentals: ({ commit }, params) => {
    return new Promise((resolve, reject) => {
      apiV1.get(`/reporting/agent-phone-rentals`, {
        params: params
      })
        .then((resp) => {
          commit("setSelectedAgentPhoneRentals", resp.data);
          resolve(resp);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
};

const mutations = {
  setSelectedAgentDeals: (state, deals) => {
    state.agentDeals = deals;
  },
  setSelectedAgentPhoneRentals: (state, phoneRentals) => {
    state.agentPhoneRentals = phoneRentals;
  }
};

export default {
  state,
  actions,
  mutations
};
